import { A11yModule } from '@angular/cdk/a11y'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { HotkeysModule } from '@helios/hotkeys'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { ButtonModule, NfFormsModule, SearchModule } from '@northfork/ng-basics'
import { PanelCardComponent } from './panel-card/panel-card.component'
import { PanelCatalogComponent } from './panel-catalog.component'

@NgModule({
  imports: [
    CommonModule,
    SearchModule,
    ReactiveFormsModule,
    ButtonModule,
    NfFormsModule,
    NgSelectModule,
    NgbTooltipModule,
    HotkeysModule,
    A11yModule,
  ],
  declarations: [PanelCatalogComponent, PanelCardComponent],
  exports: [PanelCatalogComponent],
})
export class PanelCatalogModule {}

export { PanelCatalogComponent }
